<template>
  <div class="unknown-error-page">
    <alert-page :img="require('@/assets/generic-faliure.png')"
                :title="'משהו לא עובד כרגע...'"
                :buttonTitle="'לרענן את העמוד'"
                :showButton="true"
                :button-action="onButtonClicked"
                :showSupportFooter="true"
                :button-loading="loading">
      <template v-slot:content>
          אפשר לנסות לרענן את העמוד או לחזור שוב מאוחר יותר.
      </template>
    </alert-page>
  </div>
</template>

<script>

import LoginApi from '@/api/LoginApi';
import router from '@/router';
import Segment from '../../Segment';
import AlertPage from '../../base-components/AlertPage.vue';
import MetricApi from '../../api/MetricsApi';

export default {
  name: 'ServerError',
  components: {
    AlertPage,
  },
  data() {
    return {
      loading: false,
    };
  },
  async created() {
    window.scrollTo(0, 0);
    Segment.trackUserGot('ServerErrorEntered');
    MetricApi.sendCounter('frontend.page.server-error.hits');
  },
  methods: {
    async onButtonClicked() {
      Segment.trackUserGot('ServerErrorRefreshButtonClicked');

      this.loading = true;
      const isPartiallyLoggedIn = await LoginApi.isPartialLoggedIn() && !(await LoginApi.isLoggedIn());
      if (isPartiallyLoggedIn) {
        router.push({ path: '/login' });
      } else {
        window.location.reload();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@riseupil/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .unknown-error-page {
  }
</style>
